import { Role } from '../types';

export const hasRole = (roles: Role[] = [], roleName: string) => {
    return roles.some((role) => role.roleid === roleName);
};

export const hasAnyRoles = (roles: Role[] = [], roleNames: string[]) => {
    return roles.some((role) => roleNames.indexOf(role.roleid) > -1);
};
